import { HISTORY_GET_OBJECTS, HISTORY_GET_OBJECT } from './actions.type';

import {
  WINDOW_API_ERROR_SHOW,
  HISTORY_SET_RESULT,
  HISTORY_SET_DETAILS_ID
} from './mutations.type';

import { Api as HistoryApi } from '../api/api-historia-obiektow';

const historyApi = new HistoryApi();

var getHistoriaObiektowControl = undefined;
var getHistoriaObiektowByIdControl = undefined;

const initialState = {
  historyTable: undefined,
  historyDetailsId: undefined,
  historyLoading: false
};

export const state = Object.assign({}, initialState);

export const actions = {
  async [HISTORY_GET_OBJECTS](context, payload) {
    if (context.rootGetters.featuresLayer && !context.state.historyLoading) {
      context.state.historyLoading = true;

      if (context.rootGetters.selectedMapFeatures.size > 0) {
        // ograniczenie ilości id - błąd 414 (Request-URI Too Large) przy zaznaczeniu dużej ilości obiektów
        let selectedMapFeaturesArray = Array.from(
          context.rootGetters.selectedMapFeatures
        );
        let count = 10;
        let n = selectedMapFeaturesArray.length / count;

        for (var i = 0; i < n; i++) {
          let featureIds = selectedMapFeaturesArray.slice(
            i * count,
            (i + 1) * count
          );

          await context.dispatch('getHistoriaObiektow', {
            ...payload,
            featureIdFilter: getFeatureIdFilterString(featureIds),
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null
          });
        }
      } else {
        await context.dispatch('getHistoriaObiektow', {
          ...payload,
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        });
      }
    }
  },
  async getHistoriaObiektow(context, payload) {
    //   try {
    //     const response = await historyApi.getHistoriaObiektow(
    //       {
    //         wso2_id: this.contextEmail ? this.contextEmail : null,
    //         orgid: this.contextOrganizationId
    //           ? this.contextOrganizationId
    //           : null,
    //         warstwa_id: context.rootGetters.featuresLayer.id,
    //         filter_str: payload.searchText,
    //         filter: concatFilters(
    //           payload.attributesFilter,
    //           payload.featureIdFilter
    //         ),
    //         page_number: payload.pageNumber || 1,
    //         items_per_page: payload.pageSize || 1000,
    //         order_by: payload.sortBy,
    //         desc: payload.sortDesc
    //       },
    //       { ignoreGlobalErrors: true }
    //     );
    //     if (response) {
    //       let historyTable = response.body.historia_obiektow;
    //       if (payload.append) {
    //         historyTable = context.getters.historyTable.concat(historyTable);
    //       }
    //       context.commit(HISTORY_SET_RESULT, historyTable);
    //     }
    //   } catch (error) {
    //     context.commit(WINDOW_API_ERROR_SHOW, error);
    //   } finally {
    //     context.state.historyLoading = false;
    //   }
  },
  async [HISTORY_GET_OBJECT](context) {
    var id = context.rootGetters.historyDetailsId;

    if (id) {
      try {
        const control = Date.now().toString();
        getHistoriaObiektowByIdControl = control;

        var response = await historyApi.getHistoriaObiektowById({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          id: id
        });

        if (response) {
          return response.body.historia_obiektow;
        }
        return null;
      } catch (error) {
        context.commit(WINDOW_API_ERROR_SHOW, error);
        return null;
      }
    }
  }
};

export const mutations = {
  [HISTORY_SET_RESULT](state, historyTable) {
    state.historyTable = historyTable;
  },
  [HISTORY_SET_DETAILS_ID](state, id) {
    state.historyDetailsId = id;
  }
};

export const getters = {
  historyTable(state) {
    return state.historyTable;
  },
  historyDetailsId(state) {
    return state.historyDetailsId;
  },
  historyLoading(state) {
    return state.historyLoading;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};

var concatFilters = function(str1, str2) {
  if (str1 && str2) {
    return `(${str1}) AND (${str2})`;
  }

  if (str2) {
    return str2;
  }

  return str1;
};

var getFeatureIdFilterString = function(ids) {
  var conditions = ids.map(x => `"feature_id" = "${x}"`);

  if (conditions.length > 1) {
    return conditions.reduce((x, y) => `${x} OR ${y}`);
  }
  return conditions.join('');
};
